import { OnboardingLocationPersonalized } from 'registration/components/new_pages/OnboardingLocationPersonalized/OnboardingLocationPersonalized';

export default OnboardingLocationPersonalized;
